<template>
  <div v-if="newVersionAvailable" class="version-checker">
    <div class="version-checker-content mb-2">
      <i class="fa fa-info-circle" />

      <h6>{{ $t("New version of application is available.") }}</h6>
    </div>

    <div class="text-end">
      <b-button variant="primary" size="sm" @click="loadNewVersion">
        <i class="fa fa-sync-alt me-1" /> {{ $t("Load new version") }}
      </b-button>
    </div>

    <div class="version-checker-close" @click="onCloseClick">
      <i class="fa fa-times" />
    </div>
  </div>
</template>

<script>
export default {
  name: "VersionChecker",

  data() {
    return {
      hidden: false,
    };
  },

  computed: {
    newVersionAvailable() {
      const currentVersion = this.$store.getters.currentBuildVersion;
      const availableVersion = this.$store.getters.availableBuildVersion;

      if (
        currentVersion === null ||
        availableVersion === null ||
        currentVersion === availableVersion
      ) {
        return false;
      }

      return !this.hidden;
    },
  },

  async mounted() {
    await this.$store.dispatch("getBuildVersion");
    document.addEventListener("visibilitychange", this.onVisibilityChange);
  },

  beforeUnmount() {
    document.removeEventListener("visibilitychange", this.onVisibilityChange);
  },

  methods: {
    onVisibilityChange() {
      if (document.visibilityState === "visible") {
        this.$store.dispatch("getBuildVersion");
      }
    },

    onCloseClick() {
      this.hidden = true;
    },

    loadNewVersion() {
      window.location.reload();
    },
  },
};
</script>
